<h1>Votre extrait comptable</h1>

<fs-creancier-selector *ngIf="hasMultiSuppliers" [supplierList]="suppliersList" [selectedSupplierId]="activeSupplierId"
  (selectSupplier)="fournisseurChange($event)">
</fs-creancier-selector>

<fs-filters pageName="extract-account" (filterCriteriaChange)="filterPieces($event)"></fs-filters>

<div id="download-btn-wrapper">
  <button class="ui-btn primary-btn" data-testid="accounting-extract-download"
    (click)="onClickTelechargerExtraitComptable($event)">
    <span uiSvg source="assets/images/extract-account"></span> &nbsp;
    Télécharger le fichier
  </button>
</div>

<div *ngIf="rowsInitialized">
  <fs-cdk-table tableId="extractAccount" [rows]="extractResult.Ecritures" data-testid="accounting-extract-table"
    [displayedColumns]="displayedColumns" [columns]="columns" [currentPage]="currentPage" [askedPage]="askedPage"
    [totalPages]="totalPages" [totalEntries]="totalEntries" [itemsPerPage]="itemsPerPage"
    [listSizeItemsPerPage]="listSizeItemsPerPage" (changePage)="changePage($event)" (callbackPagination)="find()"
    (changeSizePage)="onChangeSizePage($event)" (columnClicked)="onColumnClick($event)">
  </fs-cdk-table>

  <div class="empty-infos" *ngIf="extractResult.Ecritures.length === 0">
    Aucune écriture comptable trouvée
  </div>
</div>